import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "36",
  height: "36",
  fill: "none",
  viewBox: "0 0 36 36"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#FF5100",
      "stroke-width": "1.5",
      d: "m9.767 8.286.062 22.585 1.984.636 1.644.094 12.438-.824V12.5M9.767 8.286l-.01-3.483 1.716-.45c.5-.14.87-.154 1.573-.15l12.849.6V12.5M9.767 8.286l1.706 3.352c.51.72.847 1.06 1.573 1.517l12.295.15m-.018 0c.354-.187.463-.379.572-.805m-12.85-7.978v8.296m.019.698v17.921"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#FF5100",
      "stroke-width": "1.5",
      d: "m16.254 13.873-.007 1.418h6.145V10.02l-6.117-.24z"
    }, null, -1)
  ]))]))
}
export default { render: render }